module.exports = __webpack_public_path__ + "static/media/hero4.a6adb595.jpg";